import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {TimeAccountSummaryQuery, TimeEntryDay} from '@/services/api/nswag/stapiclient_generated';
import { DateTime } from 'luxon';
import { stTimeEntryApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import {TimeAccountStore} from '@/store/timeaccount-store';

export interface ITimeEntryDayUserParams {
  AppUserId: number;
  SelectedDate: DateTime;
}

@Module({ dynamic: true, store, name: 'TimeEntryModule', namespaced: true })
export default class TimeEntryModule extends VuexModule {
  public TimeEntryDays: TimeEntryDay[] = [];
  public selectedDate: DateTime | null = null;

  selectedUserId: number = 0;

  get SelectedDate(): DateTime {
    return this.selectedDate?.startOf('day') ?? UserStore.userNowDateTime.startOf('day');
  }

  @Mutation
  SetSelectedUserId(data: number) {
    this.selectedUserId = data;
  }

  @Mutation
  SetTimeEntryDays(data: TimeEntryDay[]) {
    this.TimeEntryDays = data;
  }

  @Mutation
  SetSelectedDate(data: DateTime) {
    this.selectedDate = data;
  }

  @Mutation
  Reset(resetSelectedUser: boolean) {
    this.selectedDate = null;
    this.TimeEntryDays = [];
    if (resetSelectedUser) {
      this.selectedUserId = 0;
    }
  }

  @Action
  async LoadTimeEntryDays(selectedDate: DateTime) {
    if (this.selectedUserId) {
      this.SetTimeEntryDays(await stTimeEntryApi.getListForUser(selectedDate.weekNumber, selectedDate.weekYear, this.selectedUserId));
    } else {
      this.SetTimeEntryDays(await stTimeEntryApi.getList(selectedDate.weekNumber, selectedDate.weekYear));
    }

    this.SetSelectedDate(selectedDate);

    if (UserStore.userSettings.featureFlagTimeAccountSummaryOnTimeEntryPage) {
      const query = TimeAccountSummaryQuery.fromJS({});
      query.date = selectedDate.toFormat('yyyy-MM-dd');
      query.appUserId = this.selectedUserId;
      await TimeAccountStore.LoadTimeAccountSummary(query);
    }
  }
}

export const TimeEntryStore = getModule(TimeEntryModule);
